"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var jsx_runtime_1 = require("react/jsx-runtime");
var material_1 = require("@mui/material");
var styles_1 = require("@mui/material/styles");
var Logo_1 = __importDefault(require("atomicComponents/atoms/Logo"));
var Money_1 = __importDefault(require("components/Money"));
var Text_1 = __importDefault(require("shared/components/Text"));
var StyledBox = (0, styles_1.styled)(material_1.Box)(function (_a) {
    var theme = _a.theme;
    return ({
        position: 'relative',
        transition: '.5s ease-in-out',
        border: "1px solid ".concat(theme.palette.grey[400]),
        borderRadius: 10,
        display: 'flex',
        alignItems: 'center',
        maxWidth: 275,
        padding: theme.spacing(2),
        margin: theme.spacing(1),
    });
});
var ToolItem = function (_a) {
    var teamSStats = _a.teamSStats;
    return ((0, jsx_runtime_1.jsxs)(StyledBox, { children: [(0, jsx_runtime_1.jsx)(Logo_1.default, { brand: teamSStats.service, size: "xl" }), (0, jsx_runtime_1.jsxs)(material_1.Box, __assign({ ml: 1.5, overflow: "hidden" }, { children: [(0, jsx_runtime_1.jsx)(Text_1.default, __assign({ level: 1, noWrap: true, fontWeight: 600, lineHeight: 1.25 }, { children: (teamSStats === null || teamSStats === void 0 ? void 0 : teamSStats.service) && teamSStats.service.name })), (0, jsx_runtime_1.jsxs)(Text_1.default, __assign({ level: 2, noWrap: true, lineHeight: 1.25 }, { children: [(0, jsx_runtime_1.jsx)(Money_1.default, { amount: teamSStats === null || teamSStats === void 0 ? void 0 : teamSStats.calculatedAnnualSpend }), " / yr"] }))] }))] }));
};
exports.default = ToolItem;
